export function setBottomBarText(text) {
    return { type: 'SET_BOTTOMBAR_TEXT', payload: text };
}
